import { inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, StationsService } from '../../../services';
import { StationCartItem, StationItem } from '../../../models';
import { PublicRoutes } from '../../../enums';
import { ActivatedRoute, Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationAddOnsClass {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  appState = inject(AppStateService);

  isLoading = signal(false);
  items = signal<StationCartItem[]>([]);
  routes = PublicRoutes;

  init() {
    this.getItems();
  }

  getItems() {
    if (!this.stationsService.getSelectedLocation()?.Id) {
      return;
    }
    this.isLoading.set(true);
    this.stationsService.getStationItems().subscribe({
      next: (items) => this.getItemsSuccess(items),
      error: (err) => this.getItemsFailure(err),
    });
  }

  getItemsSuccess(items: StationItem[]) {
    this.isLoading.set(false);
    const stationCartItems: StationCartItem[] = [];
    for (const item of items) {
      if (item.Category === this.appState.stationSettings.rsoCat && item.SubCategory === this.appState.stationSettings.rsoSubCat) {
        const rsoCartQty = this.stationsService.getSelectedNeedsRSO()
          ? (this.stationsService.getSelectedDuration()! / this.stationsService.getSelectedRate()!.Unit) || 0
          : 0
        const RSOItem: StationCartItem = {
          ...item,
          cartQty: rsoCartQty,
        }
        this.stationsService.setSelectedRangeSafetyOfficer(RSOItem);
        continue;
      }

      if (item.Category === this.appState.stationSettings.guestCat && item.SubCategory === this.appState.stationSettings.guestSubCat) {
        this.stationsService.setGuestItem({
          ...item,
          cartQty: 0,
        });
        continue;
      }

      const selectedItem = this.stationsService.getSelectedAddOns().find((i) => i.SkuPk === item.SkuPk);
      const cartItem: StationCartItem = {
        ...item,
        cartQty: selectedItem ? selectedItem.cartQty : 0,
      }
      stationCartItems.push(cartItem);
    }
    this.items.set(stationCartItems);
  }

  getItemsFailure(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load items');
  }

  onNextClick() {
    this.stationsService.setSelectedAddOns(this.items().filter((item) => item.cartQty));
    this.router.navigate(['../', this.routes.OPTIONS_ACCESSORIES], { relativeTo: this.route });
  }
}